import Model from '@/models/Model.js';

export default class PodcastActivity extends Model {
    static entity = 'podcast_activities';

    static fields() {
        return {
            id: this.attr(null),
            content_template_id: this.attr(null),
            content: this.attr(null),
            generation_context: this.attr(null),
            podcast_length: this.attr('STANDARD'),
            podcast_config: this.attr(null),
            script: this.attr(null),
            audio_file_path: this.attr(null),
            audio_file_disk: this.attr(null),
            audio_duration_seconds: this.attr(null),
            audio_file_size_bytes: this.attr(null),
            generation_status: this.attr('pending'),
            generation_error: this.attr(null),
            gcp_operation_name: this.attr(null),
            generation_started_at: this.attr(null),
            generation_completed_at: this.attr(null),

            ...super.fields(),

            content_template: this.belongsTo('podcast_activity_templates', 'content_template_id'),
            activity: this.morphOne('activities', 'contentable_id', 'contentable_type_entity'),
        };
    }
}
